Vendd.Scripts.load(function () {
    var $form = $('#bookTestDrive'),
        $submitButton, form, formData;

    if ($form.length < 1 || $('.x-form', $form).length < 1)
        return;

    initFormsDatePicker();
    $submitButton = $('.js-submit-button', $form);

    form = $form.get(0);

    form.ExternalService = $('.x-form', $form).attr('data-external');
    form.endpoint = $('.x-form', $form).attr('data-endpoint');
    form.language = $('.x-form', $form).attr('data-lang-code');
    form.campaignCode = $('.x-form', $form).attr('data-campaign-code');
    form.siebelService = $('.x-form', $form).attr('data-siebel');
    form.excelService = $('.x-form', $form).attr('data-excel');

    var selectCarModel = false;
    var carModel = $('.x-form', $form).attr('data-car-model');
    var $options = $('select[name="carModel"]', $form);
    var $carModelOption;

    if (carModel.length) {
        $carModelOption = $('option[value="' + carModel + '"]', $options);
    }

    if ($carModelOption && $carModelOption.length > 0) {
        selectCarModel = true;
    } else {
        //check more fuzzyly: 
        //get all options, cleanup mazda and dashes, get index of carModel -also cleaned up-, get correct option, set values
        var arr = $('option', $options).get().map(function (x) { return x.value.replace('mazda', '').replace(/-/g,'') });
        var str = carModel.replace('mazda', '').replace(/-/g, '');
        var ind = -1; 

        if (arr.length > 0) {
            ind = arr.findIndex(function (y) { return y == str });
        }

        if (ind > -1) {
            $carModelOption = $('option', $options).eq(ind);
            carModel = $carModelOption.attr('value');
            selectCarModel = true;
        }
    }

    formData = {
        "firstName": "",
        "lastName": "",
        "phoneNumber": "",
        "date": "",
        "email": "",
        // "message": "",
        "carModel": selectCarModel ? carModel : "",
        "dealerSms" : false,
        "dealerMail" : false,
        "globalSms" : false,
        "globalMail" : false,
        "dummyContact": 'seo.mazda@lighthouse.gr',
        "siteName": LhApp.Context.Request.Domain
    };

    form.updateModel = function (modelValue, modelText) {
        $('input[name="model"]', $form).val(modelText).prop("disabled", true).parent().addClass('disabled');
        formData.model = modelValue;
    }

    form.setCar = function (car, code, hideSelect) {
        $('select[name="carModel"]').val(code).change();
        formData.carModel = code;
        //Hide select box in case of used car (product)
        if (hideSelect) {
            $('.car-title .value', $form).text(car);
            $('.car-code .value', $form).text(code);
            $('select[name="carModel"]').parents('.form-row').hide();
            rf.removeField('carModel');
            $form.addClass('preselected');
        }
    }

    if (selectCarModel) {
        form.setCar('', carModel, false);
    }

    form.unsetCar = function () {
        if (selectCarModel) {
            form.setCar('', carModel, false);
            return;
        }
        $form.removeClass('preselected');
        $('select[name="carModel"]').val('_').change();
        $('select[name="carModel"]').parents('.form-row').show();
        formData.carModel = '';
    }

    form.updateBrand = function (brandValue, brandText) {
        $('input[name="brand"]', $form).val(brandText).prop("disabled", true).parent().addClass('disabled');
        formData.brand = brandValue;
    }

    form.updateProductCode = function (code) {
        formData.productCode = code;
    }

    form.loading = function (loading) {
        if (loading) {
            $form.addClass('x-loading');
        } else {
            $form.removeClass('x-loading');
        }
    };

    form.onSuccess = function () {
        if (!$form.hasClass('x-loading'))
            return;

        form.loading(false);

        $('.js-error', $form).hide();
        $('.js-content', $form).hide();
        $('.js-success', $form).css({
            'display': 'flex'
        });

        if ($(window).width() < 480) {
            var toScroll = $('.form-title-container', $form).offset().top - 20;
            $('.fancybox-inner').animate({
                scrollTop: toScroll
            }, 100, 'swing');
        }
        if (typeof window.dataLayer !== 'undefined') {
            window.dataLayer.push({'event':'formSubmitSuccess', 'formType':'bookTestDrive', 'formName':$('.full-screen-popup[data-form-btn="#'+$form.data('form-type')+'"]').data('form-name'), 'site':LhApp.Url.Page.Home});
        }

        var querystring = '?form=success';
        window.history.pushState({}, '', querystring);
    };    

    form.onFailure = function (envelope) {

        form.loading(false);
        var $errorElem = $('.js-error', $form);

        $errorElem.show();

        if ($(window).width() < 480) {
            var toScroll = $errorElem.offset().top - 20;
            $('.fancybox-inner').animate({
                scrollTop: toScroll
            }, 100, 'swing');
        }
    };

    form.submit = function () {
        form.loading(true);

        // form.trackEvent(formData);

        if (form.ExternalService == 'True') {
            form.sendNotificationExtService();
        } else {
            form.sendNotification();
        }
    };

    form.trackEvent = function (data) {
        var eventCategory = 'Book-Test-Drive-Form';

        if (eventCategory !== '') {
            ga('send', {
                hitType: 'event',
                eventCategory: eventCategory,
                eventAction: 'Submit',
                dimension1: data.brand,
                dimension2: data.model
            });
        }
    }

    form.sendNotificationExtService = function () {
        var formDataExt = {
            "firstName": formData.firstName,
            "lastName": formData.lastName,
            "mobile": formData.phoneNumber,
            "preferredDate": formData.date,
            "email": formData.email,
            "model": formData.carModel,
            "smsOptIn": formData.globalSms,
            "emailOptIn": formData.globalMail, 
            "assignToDealer": true,
            "language": form.language,
            "campaign": form.campaignCode, 
            "siebel": form.siebelService,
            "excel": form.excelService,
            "dealer": "",
            "market": "",
            "organisation": "",
            "comments": formData.date,
            "type": "Test Drive request",
            "endpoint": form.endpoint
        };
        Vendd.MessageBus.publishAsync('CustomForm', new Vendd.SubmitToExternalEndpoint.Messages.Submit(formDataExt));
    };

    form.sendNotification = function () {
        var model = formData;
        var data = { model: model, code: 'bookTestDrive' };

        Vendd.MessageBus.publishAsync('CustomForm', new Vendd.CustomForms.Messages.Submit(data));
    };

    form.reset = function () {
        $('.js-error', $form).hide();
        $('.js-exists', $form).hide();
        $('.js-success', $form).hide();
        $('.js-content', $form).show();

        $('input[name="firstName"]', $form).val("").parent().removeClass('error');
        $('input[name="lastName"]', $form).val("").parent().removeClass('error');
        $('input[name="date"]', $form).val("").parent().removeClass('error');
        $('input[name="phoneNumber"]', $form).val("").parent().removeClass('error');
        $('select[name="carModel"]', $form).val("").parent().removeClass('error');
        $('input[name="email"]', $form).val("").parent().removeClass('error');
        // $('textarea[name="message"]', $form).val("").parent().removeClass('error');

        formData = {
            "firstName": "",
            "lastName": "",
            "phoneNumber": "",
            "carModel": selectCarModel ? carModel : "",
            "date": "",
            "email": "",
            // "message": "",
            "dealerSms": false,
            "dealerMail": false,
            "globalSms": false,
            "globalMail": false,
            "dummyContact": 'seo.mazda@lighthouse.gr',
            "siteName": LhApp.Context.Request.Domain
        };

        form.unsetCar();

        rf.reset();
    };

    form.handleErrors = function (element) {
        var $errorWrappers;
        if (element === undefined) {
            $errorWrappers = $('.validator', $form);
        } else {
            $errorWrappers = element;
        }
        var emailError = false;
        var otherError = false;
        $.each($errorWrappers, function (i, wrapper) {

            var $this = $(wrapper);
            if ($this.hasClass('error')) {
                if ($this.hasClass('email-required') || $this.hasClass('email-invalid')) {
                    if (!emailError) {
                        $this.closest('.form-row').children('.input-wrapper, .textarea-wrapper, .select-wrapper').addClass('error');
                        emailError = true;
                    }
                } else {
                    $this.closest('.form-row').children('.input-wrapper, .textarea-wrapper, .select-wrapper').addClass('error');
                    otherError = true;
                }

            } else {
                if ($this.hasClass('email-required') || $this.hasClass('email-invalid')) {
                    if (!emailError) {
                        $this.closest('.form-row').children('.input-wrapper, .textarea-wrapper, .select-wrapper').removeClass('error');
                    }
                } else {
                    if (!otherError) {
                        $this.closest('.form-row').children('.input-wrapper, .textarea-wrapper, .select-wrapper').removeClass('error');
                    }
                }

            }
        });

        if (element === undefined) {
            var errorElem = $('.error:first', $form);
            if (errorElem.length > 0) {
                var toScroll = $('.error:first', $form).offset().top - 150;
                $form.animate({
                    scrollTop: toScroll
                }, 500, 'swing');
                $('input, select, textarea', errorElem).focus();
            }
        }
    }

    var valOpts = {
        firstName: {
            required: 'firstName-required'
        },
        lastName: {
            required: 'lastName-required'
        },
        phoneNumber: {
            required: 'phoneNumber-required',
            isPhone: 'phoneNumber-invalid'
        },
        date : {
            required: 'date-required'
        },
        carModel: {
            selectNotEmpty: 'carModel-required'
        },
        // message: {
        //     required: 'message-required'
        // },
        email: {
            required: 'email-required',
            isEmail: 'email-invalid'
        }
    };

    $form.validationEngine(valOpts);
    var rf = $form.data('validationEngine');

    $form.on('click', '.js-submit-button', function (e) {

        valOpts = $form.validationEngine();
        $form.validationEngine(valOpts);
        rf = $form.data('validationEngine');

        e.preventDefault();
        e.stopPropagation();
        var val1 = rf.validate();

        if (val1) {
            form.submit();
        } else {
            form.handleErrors();
        }
        //console.log("submit === ", formData)
    });

    $form.on('keyup', 'input[name], textarea[name]', function (e) {

        if (e.keyCode === 13) {
            if ($(this).prop("tagName").toLowerCase() === "textarea")
                return true;

            e.preventDefault();
            e.stopPropagation();

            $submitButton.click();

            return;
        };

        var $this = $(this);
        var fieldName = $this.attr('name');

        formData[fieldName] = $this.val();
        rf = $form.data('validationEngine');
        rf.validate(fieldName);
        form.handleErrors($('.validator', $(this).parents('.form-row')));
    });

    $(".accordion",$form).click(function () {
        if ($(this).hasClass("expanded")) {
            $(this).removeClass("expanded");
            $(this).siblings().removeClass('expanded')
        }
        else {
            $(this).removeClass("expanded");
            $(this).addClass("expanded");
            $(this).siblings().addClass('expanded')
        }
    });
    $form.on('click', 'input[type="checkbox"]', function (e) {
        policy = $(this).attr('name');
        if ($(this).is(':checked')) {
            formData[policy] = true;
        } else {
            formData[policy] = false;
        }
    });

    $('select', $form).sSelect().change(function () {
        var $this = $(this);
        var fieldName = $this.attr('name');
        formData[fieldName] = $this.val();

        rf = $form.data('validationEngine');
        rf.validate(fieldName);
        form.handleErrors($('.validator', $(this).parents('.form-row')));
    });

    $('input', $form).focus(function () {
        $(this).parent('div').addClass('focus');
    }).blur(function () {
        $(this).parent('div').removeClass('focus');;
    });

    $('textarea', $form).focus(function () {
        $(this).parent('div').addClass('focus');
    }).blur(function () {
        $(this).parent('div').removeClass('focus');;
    });

    $('a[href^="confId"]').on('click', function (e) {
        e.preventDefault();

        var url = $(this).prop('href').split('?');
        $.each(url, function (i, el) {
            if (el.split('=')[0] == 'inquiryCode') {
                inquiryCode = el.split('=')[1];
            }
            if (el.split('=')[0] == 'familyCode') {
                familyCode = parseInt(el.split('=')[1]);
            }
        });
    });

    $('a[href^="promo="]').on('click', function (e) {
        e.preventDefault();

        promoCode = $(this).prop('href').split("=")[1];
        if (promoCode !== '' && promoCode !== undefined) {
            $('#inquiryCode').text(promoCode);
            $('.full-screen-popup').attr('href', '#interestFormConfigurator');
            $('.full-screen-popup').click();
        }
    });

    function initFormsDatePicker() {
        $form.find('.calendar input').datetimepicker({
            timepicker: false,
            validateOnBlur: true,
            weeks: false,
            format: 'd/m/Y',
            startDate: new Date(),
            dayOfWeekStart: 1,
            minDate: new Date(),
            disabledWeekDays: [0, 6],
            onChangeDateTime:function(dp,$input){
                formData.date = $input.val();
                fieldName = $input.attr('name');

                rf = $form.data('validationEngine');
                rf.validate(fieldName);
                form.handleErrors($('.validator', $input.parents('.form-row')));
              }
        });
        var current_language = $('html').attr('lang');
        $.datetimepicker.setLocale(current_language);
    }

    $(form).on('scroll', function () {
        $('.xdsoft_datetimepicker').each(function(){
            $(this).css('display','none');
        })
    });

    Vendd.MessageBus.subscribe(Vendd.CustomForms.Messages.SubmitSuccess, form, function (envelope) {
        var response = envelope.message.data;
        if (response.Success) {
            form.onSuccess();
        } else {
            form.onFailure();
        }
    });

    Vendd.MessageBus.subscribe(Vendd.SubmitToExternalEndpoint.Messages.CreateLeadSuccess, form, function (envelope) {
        var response = envelope.message.data;
        if (response) {
            form.onSuccess();
        } else {
            form.onFailure();
        }
    });

    Vendd.MessageBus.subscribe(Vendd.SubmitToExternalEndpoint.Messages.CreateLeadFailure, form, function (envelope) {
            form.onFailure();
    });
});